export class WelcomeOnboardingWidget extends HTMLElement {

	public connectedCallback(): void {
		const firstName = this.getAttribute("data-firstname");
		const identifier = this.getAttribute("data-identifier");
		const login = this.getAttribute("data-login");
		this.innerHTML = `
				<div class="panel panel-flat">
					<div class="panel-heading">
						<h2 class="panel-title">${messages["onboardingDashboard.welcomeToTimr"]}, ${firstName}!</h2>
					</div>	
					<div class="panel-body">
						${messages.withArguments("onboardingDashboard.welcome.body", identifier, login)}
						<div class="panel panel-info panel-body mt-10 pt-5 pb-5">
							${messages["onboardingDashboard.welcome.hint"]}
						</div>
					</div>
				</div>`;
	}

}


